import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import { camelizeKeys } from "lib/helpers";
import messages from "rdx/modules/compensation/messages";

function* getProjectsCompensationList(action) {
  const { success, data, error } = yield* makeRequest.get("/compensation/projects", action.payload);

  if (success && data) {
    yield put(actions.setProjectsCompensationList(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_PROJECTS_COMPENSATION,
    });
  }

  return null;
}

export default getProjectsCompensationList;
